import type { IconData } from '@stacksjs/iconify-core'

export const chevronDownLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 8h7a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronDownLeft
